<!-- Management -->
<ng-container *ngFor="let pos of leftWindowPositions(); let rowIndex = index; trackBy: trackByIndex">
    <svg:g
        class="window-left"
        [style.animationDelay]="rowIndex * 0.01 + 's'">
        <svg:g [attr.transform]="'translate(' + pos.x + ', ' + pos.y + ')'">
            <path
                d="M70 80 L1 36 L0 0 L70 44 L70 80 Z"
                fill="var(--window-lit-bg-1)" />
        </svg:g>
    </svg:g>
</ng-container>

<ng-container *ngFor="let pos of rightWindowPositions(); let rowIndex = index; trackBy: trackByIndex">
    <svg:g
        class="window-right"
        [style.animationDelay]="rowIndex * 0.01 + 's'">
        <svg:g [attr.transform]="'translate(' + pos.x + ', ' + pos.y + ')'">
            <path
                d="M0 32 L0 69 L54 37 L54 0 L0 32 Z"
                fill="var(--window-dark-bg-2)" />
        </svg:g>

        <svg:g [attr.transform]="'translate(' + pos.a + ', ' + pos.b + ')'">
            <path
                d="M0.626953 24.958L22.4602 12.378L22.4494 0.425293L0.626953 13.0053V24.958Z"
                fill="var(--window-dark-bg-2)" />
            <path
                d="M0.626953 20.8221V24.958L22.4602 12.378L22.4494 0.425293L19.1112 2.35878L19.1156 10.1644L0.626953 20.8221Z"
                fill="var(--window-shade-bg-1)" />
        </svg:g>

        <svg:g [attr.transform]="'translate(' + pos.c + ', ' + pos.d + ')'">
            <path
                d="M0.626953 24.958L22.4602 12.378L22.4494 0.425293L0.626953 13.0053V24.958Z"
                fill="var(--window-lit-bg-2)" />
            <path
                d="M0.626953 20.8221V24.958L22.4602 12.378L22.4494 0.425293L19.1112 2.35878L19.1156 10.1644L0.626953 20.8221Z"
                fill="var(--window-shade-bg-1)" />
        </svg:g>

        <svg:g [attr.transform]="'translate(' + pos.e + ', ' + pos.f + ')'">
            <path
                d="M0.626953 24.958L22.4602 12.378L22.4494 0.425293L0.626953 13.0053V24.958Z"
                fill="var(--window-lit-bg-2)" />
            <path
                d="M0.626953 20.8221V24.958L22.4602 12.378L22.4494 0.425293L19.1112 2.35878L19.1156 10.1644L0.626953 20.8221Z"
                fill="var(--window-shade-bg-1)" />
        </svg:g>

        <svg:g [attr.transform]="'translate(' + pos.g + ', ' + pos.h + ')'">
            <path
                d="M0.626953 24.958L22.4602 12.378L22.4494 0.425293L0.626953 13.0053V24.958Z"
                fill="var(--window-dark-bg-2)" />
            <path
                d="M0.626953 20.8221V24.958L22.4602 12.378L22.4494 0.425293L19.1112 2.35878L19.1156 10.1644L0.626953 20.8221Z"
                fill="var(--window-shade-bg-1)" />
        </svg:g>
    </svg:g>
</ng-container>


    
